import React from "react";
import "./HomeWork.css";
import bannerImg from "../../Assets/Home/banner.png";
import { workProcess } from "../../utils/WorkProcess";
import { Link } from "react-router-dom";

const HomeWork = () => {
  return (
    <div className="HomeWork-container">
      <img src={bannerImg} alt="" />
      <div className="homeWrokDetailsWrapper">
        <span className="HomworkProcessHead">Our Work Process</span>
        <span className="HomworkProcessPara">
          At Techni Trust Technical Services, we follow a clear and efficient
          process. We start by understanding your needs, planning the best
          solutions, and using skilled experts to complete the work on time. We
          ensure high-quality results, safety, and customer satisfaction at
          every step.
        </span>
        <div className="WCardList">
          {workProcess.map((work) => (
            <div className="workCard">
              <span className="workiconWrapper">
                <work.icon />
              </span>
              <span className="workprocessHead">{work.name}</span>
            </div>
          ))}
        </div>
        <Link to={"/about"}>
          <button class="button">Explore More</button>
        </Link>
      </div>
    </div>
  );
};

export default HomeWork;
